import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const exactLoaderSlice = createSlice({
    name: "exactLoader",
    initialState: { value: false },
    reducers: {
        setExactLoader: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const negativeLoaderSlice = createSlice({
    name: "negativeLoader",
    initialState: { value: false },
    reducers: {
        setNegativeLoader: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { setExactLoader } = exactLoaderSlice.actions;
export const { setNegativeLoader } = negativeLoaderSlice.actions;

export const exactLoaderReducer = exactLoaderSlice.reducer;
export const negativeLoaderReducer = negativeLoaderSlice.reducer;